/*
 * サブシステム名：請求消込
 * 機能名：入金未消込一覧
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'

import dolly from '@/rahmen/utils/dolly'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'

import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDateRangeBox = () => import('@/components/DdDateRangeBox')
const DdListHeader = () => import('@/components/DdListHeader')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'NyukinMiKeshikomiList',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCheckbox,
    DdCodeTextBox,
    DdDateRangeBox,
    DdListHeader,
    DdNumericBox,
    DdRadioButton,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      nyukinYmdFromString: '',
      nyukinYmdToString: '',
      nyukinsakiId: '',
      hyojiMode: '0',
      nyukinYoteiYmdFromString: '',
      nyukinYoteiYmdToString: '',
      seikyusakiId: '',
      tantoshaId: ''
    },
    conditionsSearch: {},
    rows: [],
    rec: {
      sagakuFurikomiTesuryoFlg: false,
      furikomiTesuryoJogen: '',
      dateText: ''
    },
    rowsDisp: [],
    on: '',
    attrs: '',
    hyojiModeKubun: '0',
    headersJininList: header.mstJininHeaders,
    headersNyukinsakiList: header.mstTorihikisakiHeaders,
    headersSeikyusakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiNyukinsakiList: 'DDMasters/vwCMstTorihikisakiGetNyukinsaki',
      torihikisakiSeikyusakiList: 'DDMasters/vwCMstTorihikisakiGetSeikyusaki',
      kinoList: 'DDMasters/msysKino',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    filteredRows () {
      return this.rowsDisp.map((elem) => {
        // 表示フォーマット編集
        elem.nyukinKingaku = filter.numericFormatter(elem.nyukinKingaku)
        elem.seikyuKingaku = filter.numericFormatter(elem.seikyuKingaku)
        elem.sagaku = filter.numericFormatter(elem.sagaku)
        switch (elem.furikomiTesuryoFlg) {
          case true:
            elem.furikomiTesuryoKbn = 1
            break
          case false:
            elem.furikomiTesuryoKbn = 2
            break
          default:
            elem.furikomiTesuryoKbn = 0
        }
        return elem
      })
    },
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredJininList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
              (self.eigyoshoLockFlg || elem.eigyoshoCd === self.userEigyoshoCd)
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    filteredNyukinsakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiNyukinsakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredSeikyusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiSeikyusakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredKinoList () {
      return this.kinoList.filter((elem) => {
        return elem.viewNm === 'bcl-seikyukeshikomi-edit'
      })
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0) {
        return true
      }
      return false
    },
    isSaveButtonDisabled () {
      // 表示モード：一覧の検索結果を選択して詳細消込を行う
      return this.rowsDisp.length === 0 || this.hyojiModeKubun === '1'
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        rowsDisp: this.rowsDisp,
        conditions: this.conditions,
        rec: this.rec
        // searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['vwcmsteigyoshojininlist', 'vwcmsttorihikisakigetnyukinsaki', 'vwcmsttorihikisakigetseikyusaki', 'msyskino', 'msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('D2BCLD0030.defineHeaderPromise')
            self.headers = [
              { text: '入金選択', value: 'nyukinSentaku', align: 'center', sortable: false },
              { text: '入金先コード/名称', value: 'nyukinsakiNm', sortable: false },
              { text: '入金金額（合算）', value: 'nyukinKingaku', align: 'end', sortable: false },
              { text: '合算件数', value: 'nyukinKensu', sortable: false },
              { text: '差額', value: 'sagaku', align: 'end', sortable: false },
              { text: '請求選択', value: 'seikyuSentaku', align: 'center', sortable: false },
              { text: '請求先コード/名称', value: 'seikyusakiNm', sortable: false },
              { text: '請求残高（合算）', value: 'seikyuKingaku', align: 'end', sortable: false },
              { text: '請求書件数', value: 'seikyuKensu', sortable: false }]
            resolve()
          })
        },
        initializeInputPromise: function () {
          var dt = new Date()
          dt.setMonth(dt.getMonth() - 3)
          return new Promise((resolve) => {
            self.conditions = {
              nyukinYmdFromString: filter.dateFormatter(dt),
              nyukinYmdToString: filter.dateFormatter(new Date()),
              nyukinsakiId: '',
              hyojiMode: '0',
              nyukinYoteiYmdFromString: '',
              nyukinYoteiYmdToString: filter.dateFormatter(new Date()),
              seikyusakiId: '',
              tantoshaId: ''
            }
            self.rec = {
              sagakuFurikomiTesuryoFlg: false,
              furikomiTesuryoJogen: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('D2BCLD0030.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          if (Object.keys(c).length !== 0) {
            var furikomiTesuryoFlgBool = c.sagakuFurikomiTesuryoFlg === 'true'
            self.rec.sagakuFurikomiTesuryoFlg = furikomiTesuryoFlgBool
            self.rec.furikomiTesuryoJogen = c.furikomiTesuryoJogen
            self.conditions.hyojiMode = c.hyojiMode
          }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('D2BCLD0030.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('D2BCLD0030.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            // self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            self.rowsDisp = c.cache.value ? c.cache.value.rowsDisp || [] : self.rowsDisp
            self.rec = c.cache.value ? c.cache.value.rec || {} : self.rec
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    /*
     * ボタン処理
     */
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/D2bcld0030/searchChildren', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rowsDisp = []
          var rowDisp = {}
          // 検索結果を格納
          self.rows = data.payload

          // 画面表示用にデータ整形
          var wkList = JSON.parse(JSON.stringify(data.payload))
          // 一意になる値
          var seq = 0
          wkList.forEach(elem => {
            if (elem.seikyuList.length === 0) {
              // 入金先に紐づく消込可能な請求先が存在しない場合
              // 請求先をもとに画面表示用配列を作成するため請求先を強制的に作成
              elem.seikyuList = []
              rowDisp = {}
              rowDisp.id = 0
              rowDisp.seikyuKingaku = 0
              rowDisp.nyukinsakiId = elem.id
              rowDisp.nyukinsakiNm = elem.nyukinsakiNm
              rowDisp.nyukinKingaku = elem.nyukinKingaku
              rowDisp.nyukinKensu = elem.nyukinKensu
              rowDisp.furikomiTesuryoFlg = elem.furikomiTesuryoFlg
              elem.seikyuList.push(rowDisp)
            }

            elem.seikyuList.forEach((elem, index) => {
              rowDisp = {}
              // 一意になる値
              seq = seq + 1
              rowDisp.id = seq
              // 表チェックボックス項目
              rowDisp.nyukinSentaku = false
              rowDisp.seikyuSentaku = false
              rowDisp.seikyusakiId = elem.id
              rowDisp.seikyusakiNm = elem.seikyusakiNm
              rowDisp.seikyuKingaku = elem.seikyuKingaku
              rowDisp.seikyuKensu = elem.seikyuKensu
              rowDisp.furikomiTesuryoFlg = elem.furikomiTesuryoFlg
              rowDisp.nyukinsakiId = elem.nyukinsakiId
              rowDisp.sagaku = 0
              // 入金先に紐づく請求先が複数件の場合、1行目のみ入金情報を表示
              if (index !== 0) {
                rowDisp.hyojiFlg = false
                rowDisp.nyukinsakiNm = ''
                rowDisp.nyukinKingaku = 0
                rowDisp.nyukinKensu = 0
              } else {
                rowDisp.hyojiFlg = true
                rowDisp.nyukinsakiNm = elem.nyukinsakiNm
                rowDisp.nyukinKingaku = elem.nyukinKingaku
                rowDisp.nyukinKensu = elem.nyukinKensu
              }
              // 画面表示用配列に追加
              self.rowsDisp.push(rowDisp)
            })
          })
          // 表示モードを設定
          // 検索実行後に表示モードを変更されることを考慮
          self.hyojiModeKubun = self.conditions.hyojiMode
          // 検索実行時の検索条件を取得
          self.conditionsSearch = JSON.parse(JSON.stringify(self.conditions))
          // 一覧に表示する文章を設定
          self.rec.dateText = self.conditions.nyukinYmdToString + '時点での請求残高'

          // 差額を計算（表示モードによって異なる）
          if (self.hyojiModeKubun === '0') {
            // 表示モード：一覧の検索結果で消込を行う
            // 未選択状態の差額を表示（0になる）
            self.onReleaseAllButtonClick()
          } else {
            // 表示モード：一覧の検索結果を選択して詳細消込を行う
            // 全選択状態の差額を表示
            self.onSelectAllButtonClick()
          }

          const cache = {
            rows: self.rows,
            rowsDisp: self.rowsDisp,
            conditions: self.conditions,
            // searchText: self.searchText
            rec: self.rec
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            hyojiMode: self.conditions.hyojiMode
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      var dt = new Date()
      dt.setMonth(dt.getMonth() - 3)
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.rec = {
              // sagakuFurikomiTesuryoFlg: false,
              furikomiTesuryoJogen: ''
            }
            this.conditions = {
              nyukinYmdFromString: filter.dateFormatter(dt),
              nyukinYmdToString: filter.dateFormatter(new Date()),
              nyukinsakiId: '',
              hyojiMode: '0',
              nyukinYoteiYmdFromString: '',
              nyukinYoteiYmdToString: filter.dateFormatter(new Date()),
              seikyusakiId: '',
              tantoshaId: ''
            }
            // this.searchText = ''
            this.rows = []
            this.rowsDisp = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.clear()
    },
    onRowClickCustom: function (row) {
      if (this.hyojiModeKubun !== '1') {
        // 「表示モード：一覧の検索結果を選択して詳細消込を行う」以外
        return
      }
      if (row.seikyusakiId === 0) {
        // 入金先に紐づく請求先が存在しない場合
        return
      }
      // this.Effects.loadStart()
      const p = modals.showConfirm
      p('COMQ0011', '', '', [this.filteredKinoList[0].kinoNm, '']).then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.cloneData = dolly.clone(this.getCloneTargetMethod())
        var param = {}
        param.nyukinsakiId = row.nyukinsakiId
        param.nyukinYmdFromString = this.conditions.nyukinYmdFromString
        param.nyukinYmdToString = this.conditions.nyukinYmdToString
        param.seikyusakiId = this.conditions.seikyusakiId
        param.nyukinYoteiYmdFromString = this.conditions.nyukinYoteiYmdFromString
        param.nyukinYoteiYmdToString = this.conditions.nyukinYoteiYmdToString
        this.transition(1, { id: 0, param: param })
      })
    },
    searchValidate: function () {
      console.log('searchValidate')
      var msg
      // 入金日の大小チェック
      if (this.conditions.nyukinYmdFromString !== undefined && this.conditions.nyukinYmdToString !== undefined) {
        msg = validators.compareDate(this.conditions.nyukinYmdFromString, this.conditions.nyukinYmdToString)
        if (msg !== undefined) {
          this.$refs.nyukinYmdFromString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.nyukinYmdToString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      // 入金予定日の大小チェック
      if (this.conditions.nyukinYoteiYmdFromString !== undefined && this.conditions.nyukinYoteiYmdToString !== undefined) {
        msg = validators.compareDate(this.conditions.nyukinYoteiYmdFromString, this.conditions.nyukinYoteiYmdToString)
        if (msg !== undefined) {
          this.$refs.nyukinYoteiYmdFromString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.nyukinYoteiYmdToString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      return true
    },
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            // 登録処理後に再検索するためにここでメッセージ表示
            self.setInvalidSummaryMessage(data.summaryMessage.messageCd)
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            self.id = id
            self.conditions = JSON.parse(JSON.stringify(self.conditionsSearch))
            // self.transition(0, { id: id }, self.initialize)
            // 登録処理後に再検索
            self.onSearchButtonClick()
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          // return self.id !== 0
          // 更新処理後に画面遷移しないため
          return false
        },
        getSavedInputMethod: function () {
          return {
            sagakuFurikomiTesuryoFlg: self.rec.sagakuFurikomiTesuryoFlg,
            furikomiTesuryoJogen: self.rec.furikomiTesuryoJogen
          }
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      // 更新用配列に一覧を追加
      this.rec.registerList = this.rows

      var f = this.HttpClient.post('/api/v1/D2bcld0030/CreateMulti', this.rec)
      return f
    },
    registerValidate: function () {
      var seikyuList
      // 入金と請求が選択済の消込登録対象データが存在しない
      var normal = this.rows.filter((nyukinsaki) => {
        seikyuList = nyukinsaki.seikyuList.filter(seikyusaki => seikyusaki.keshikomiFlg === true)
        return nyukinsaki.keshikomiFlg === true && seikyuList.length !== 0
      })
      if (normal.length === 0) {
        this.setInvalidSummaryMessage('BCLE0003')
        return false
      }
      // 入金と請求の片方のみが選択済の消込登録対象になり得ないデータが存在する
      var irregular = this.rows.filter((nyukinsaki) => {
        seikyuList = nyukinsaki.seikyuList.filter(seikyusaki => seikyusaki.keshikomiFlg === true)
        return (nyukinsaki.keshikomiFlg === true && seikyuList.length === 0) || (nyukinsaki.keshikomiFlg === false && seikyuList.length !== 0)
      })
      if (irregular.length !== 0) {
        this.setInvalidSummaryMessage('BCLE0003')
        return false
      }
      return true
    },
    onSelectAllButtonClick: function (e) {
      const self = this
      return new Promise(resolve => {
        self.rowsDisp.forEach(elem => {
          if (elem.seikyusakiId !== 0) {
            // 入金先に紐づく請求先が存在する行
            if (elem.hyojiFlg === true) {
              // 入金先に紐づく請求先1件目の行
              self.sentakuNyukin(true, elem)
            }
            self.sentakuSeikyu(true, elem)
          }
        })
        resolve()
      })
    },
    onReleaseAllButtonClick: function (e) {
      const self = this
      return new Promise(resolve => {
        self.rowsDisp.forEach(elem => {
          if (elem.seikyusakiId !== 0) {
            // 入金先に紐づく請求先が存在する行
            if (elem.hyojiFlg === true) {
              // 入金先に紐づく請求先1件目の行
              self.sentakuNyukin(false, elem)
            }
            self.sentakuSeikyu(false, elem)
          }
        })
        resolve()
      })
    },
    /* ******************
     * 表項目
     ****************** */
    /*
     * 入金選択
     */
    sentakuNyukin: function (e, row) {
      return new Promise(resolve => {
        // 入金先IDを取得
        var nyukinsakiId = row.nyukinsakiId
        // 更新対象のインデックスを取得（入金先）
        var targetIdxNyukin = this.rows.findIndex(elem => elem.id === nyukinsakiId)
        // 更新対象のインデックスを取得（画面表示）
        var targetIdxDisp = this.rowsDisp.findIndex(elem => elem.id === row.id)

        if (e === true) {
          // 入金選択ONの場合
          this.rows[targetIdxNyukin].keshikomiFlg = true
          this.rowsDisp[targetIdxDisp].nyukinSentaku = true
        } else {
          this.rows[targetIdxNyukin].keshikomiFlg = false
          this.rowsDisp[targetIdxDisp].nyukinSentaku = false
        }
        // 差額計算
        this.calcSagaku(nyukinsakiId, targetIdxNyukin)
        resolve()
      })
    },
    /*
     * 請求選択
     */
    sentakuSeikyu: function (e, row) {
      return new Promise(resolve => {
        // 入金先IDを取得
        var nyukinsakiId = row.nyukinsakiId
        // 請求先IDを取得
        var seikyusakiId = row.seikyusakiId
        // 更新対象のインデックスを取得（入金先）
        var targetIdxNyukin = this.rows.findIndex(elem => elem.id === nyukinsakiId)
        // 更新対象のインデックスを取得（請求先）
        var targetIdxSeikyu = this.rows[targetIdxNyukin].seikyuList.findIndex(elem => elem.id === seikyusakiId)
        // 更新対象のインデックスを取得（画面表示）
        var targetIdxDisp = this.rowsDisp.findIndex(elem => elem.id === row.id)

        if (e === true) {
          // 請求選択ONの場合
          this.rows[targetIdxNyukin].seikyuList[targetIdxSeikyu].keshikomiFlg = true
          this.rowsDisp[targetIdxDisp].seikyuSentaku = true
        } else {
          this.rows[targetIdxNyukin].seikyuList[targetIdxSeikyu].keshikomiFlg = false
          this.rowsDisp[targetIdxDisp].seikyuSentaku = false
        }
        // 差額計算
        this.calcSagaku(nyukinsakiId, targetIdxNyukin)
        resolve()
      })
    },
    /*
     * 差額計算
     */
    calcSagaku: function (nyukinsakiId, targetIdxNyukin) {
      return new Promise(resolve => {
        // 請求選択済の請求金額
        var seikyuKeshikomiKingaku = 0
        seikyuKeshikomiKingaku = this.rows[targetIdxNyukin].seikyuList.reduce((sum, i) => {
          var keshikomiKingaku = i.keshikomiFlg ? i.seikyuKingaku : 0
          return sum + keshikomiKingaku
        }, 0)
        // 入金選択済の入金金額
        var nyukinKeshikomiKingaku = this.rows[targetIdxNyukin].keshikomiFlg ? this.rows[targetIdxNyukin].nyukinKingaku : 0
        var sagaku = seikyuKeshikomiKingaku - nyukinKeshikomiKingaku
        // 画面表示用配列の値を変更
        var targetIdxDisp = this.rowsDisp.findIndex(elem => (elem.nyukinsakiId === nyukinsakiId) && (elem.hyojiFlg === true))
        this.rowsDisp[targetIdxDisp].sagaku = sagaku
        // 更新用配列の値を変更
        this.rows[targetIdxNyukin].sagaku = sagaku
        resolve()
      })
    }
  }
}
